<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import PlanAPI from 'dashboard/api/plan';
import { frontendURL } from 'dashboard/helper/URLHelper';

const router = useRouter();
const route = useRoute();
const enforcement = ref(null);

const banner = computed(() => enforcement.value?.banner);
const isBlocked = computed(() => enforcement.value?.blocked);

const bannerClasses = computed(() => {
  if (!banner.value) return '';
  const map = {
    info: 'bg-n-blue-3 border-n-blue-6 text-n-blue-11',
    warning: 'bg-n-amber-3 border-n-amber-6 text-n-amber-11',
    error: 'bg-n-ruby-3 border-n-ruby-6 text-n-ruby-11',
    critical: 'bg-n-ruby-9 border-n-ruby-11 text-white',
  };
  return map[banner.value.level] || map.warning;
});

const fetchEnforcement = async () => {
  try {
    const { data } = await PlanAPI.enforcement();
    enforcement.value = data;
  } catch {
    // silencioso
  }
};

const goToPlan = () => {
  const accountId = route.params.accountId;
  if (accountId) {
    router.push(frontendURL(`accounts/${accountId}/settings/plan`));
  }
};

onMounted(fetchEnforcement);
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div
    v-if="banner"
    class="w-full px-4 py-2.5 border-b flex items-center justify-between text-sm"
    :class="bannerClasses"
  >
    <span>{{ banner.message }}</span>
    <button
      class="px-3 py-1 rounded-lg font-semibold text-xs bg-white/20 hover:bg-white/30 backdrop-blur"
      @click="goToPlan"
    >
      {{ isBlocked ? 'Regularizar agora' : 'Ver plano' }}
    </button>
  </div>
</template>
